import React, { useContext, useEffect, useState } from "react";
import CourseTham from "../../../assets/Dashboard/CourseTham.png";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthProvider";
import { useParams } from "react-router-dom";
import Navbar from "./Navbar";
import "./style.css";
import Swal from "sweetalert2";
import DialogLayoutForFromControl from "../Shared/DialogLayoutForFromControl";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import { GoogleAuthProvider, onAuthStateChanged, getAuth, fetchSignInMethodsForEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Loading from "../../Shared/Loading/Loading";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { Helmet } from "react-helmet";
import NavbarSkeletonLoader from "./NavbarSkeletonLoader";
import ForgotPassword from "./ForgotPassword";
import toast from "react-hot-toast";

const BundlePayment = () => {
  const {
    userInfo,
    user,
    signIn,
    providerLogin,
    logOut,
    createUser,
    setUserInfo,
  } = useContext(AuthContext);
  const { id } = useParams();
  const [course, setCourse] = useState([]);
  const [batchesData, setBatchesData] = useState([]);
  const [organizationData, setOrganizationData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState({});
  const [offers, setOffers] = useState([]);
  const [selectOffer, setSelectedOffer] = useState("");
  const [coupon, setCoupon] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [forgotPassOpen, setForgotPassOpen] = useState(false);

  const dateCreated = new Date();

  const fetchOffers = async (bundleId) => {
    const offers = await axios.get(
      `${process.env.REACT_APP_SERVERLESS_API}/api/v1/offers/bundleId/${bundleId}`
    );
    setOffers(offers?.data?.result);
    setCoupon("");
    setSelectedOffer("");
    setCouponDiscount(0);
    // console.log("Offers  ================>", offers?.data?.result);
  };

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_SERVERLESS_API}/api/v1/bundles/bundleId/${id}`
      )
      .then((response) => {
        setCourse(response?.data);
        fetchOffers(response?.data?._id);
      })
      .catch((error) => console.error(error));
  }, [id]);

  useEffect(() => {
    if (course?.organization?.organizationId)
      axios
        .get(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v1/organizations/${course?.organization?.organizationId}`
        )
        .then((response) => {
          setOrganizationData(response?.data);
        })
        .catch((error) => console.error(error));
  }, [course, course?.organization?.organizationId]);

  // Prevent navigation during registration save to avoid race conditions
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isSaving) {
        e.preventDefault();
        e.returnValue = 'Registration is in progress. Are you sure you want to leave?';
        return 'Registration is in progress. Are you sure you want to leave?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isSaving]);

  // useEffect(() => {
  //   fetchOffers(selectedBatch?._id);
  //   // console.log("Offers  ==============>", offers);
  // }, [selectedBatch]);

  const date = new Date(course?.courseStartingDate);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const handleApplyCoupon = (coupon) => {
    const filteredCoupon = offers.filter(
      (offer) => offer.code === coupon && offer.disabled !== true
    );
    if (filteredCoupon.length > 0) {
      // console.log(filteredCoupon[0]);
      setSelectedOffer(filteredCoupon[0]);
      let { discountPercent, maxDiscountValue, minCourseValue } =
        filteredCoupon[0];
      let discountAmount = (+course?.price * +discountPercent) / 100;
      // console.log("Discount Amount", discountAmount);
      if (discountAmount > +maxDiscountValue)
        discountAmount = +maxDiscountValue;

      // console.log("Discount Amount", discountAmount);
      if (+minCourseValue <= +course?.price) setCouponDiscount(discountAmount);
      else {
        Swal.fire({
          title: `Error`,
          text: `Minimum Course Price should be  ₹${minCourseValue}`,
          icon: "error",
        });
        setCouponDiscount(0);
      }
    } else {
      Swal.fire({
        title: "Coupon Doesn't Exist",
        icon: "error",
      });
    }
  };

  const handleBundlePaymentRetry = async (response) => {
    Loading();
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users/unpaidUsers/verifyBundlePayment`,
        response
      );

      Loading().close();

      if (res.data.success) {
        setUserInfo(res.data.userData);
        Swal.fire({
          title: "Courses Added Successfully",
          text: "Bundle payment verification successful!",
          icon: "success",
        });

        // Clear failed payment from storage
        localStorage.removeItem("failedBundlePayment");
        navigate("/courseAccess");
      } else {
        Swal.fire({
          title: "Verification Still Failed",
          text: "Please contact support for manual verification.",
          icon: "error",
        });
      }
    } catch (error) {
      Loading().close();
      Swal.fire({
        title: "Retry Failed",
        text: "Please contact support for manual verification.",
        icon: "error",
      });
    }
  };

  const handleEnroll = async (data) => {
    // console.log("Went to Line 124");
    // console.log("Data =============>", data);
    Loading();

    if (+course?.price - +couponDiscount === 0) {
      const enrollData = {
        courses: course?.courses, // Array of objects, each containing courseId and batchId
        coupon: coupon || "",
        couponId: selectOffer._id || "",
        discountAmount: Math.round(+couponDiscount) || "",
        email: data?.email,
        organizationId: organizationData?._id,
        organizationName: organizationData?.organizationName,
        originalPrice: Math.round(+course?.price),
        paidAmount: 0,
        userId: data?._id,
      };
      // console.log("EnrollData ============>", enrollData);
      const res = await axios.post(
        // `http://localhost:5000/api/v1/users/unpaidUsers/enroll`,
        `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users/unpaidUsers/enroll`,
        enrollData
      );
      // console.log("Free Response =========>", res);
      if (res.data.success) {
        // Fetch complete user data including courses
        try {
          const userResponse = await axios.get(
            `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${data?.email}`
          );
          setUserInfo(userResponse.data);
          localStorage.setItem("userInfo", JSON.stringify(userResponse.data));
        } catch (error) {
          console.error("Error fetching complete user data:", error);
          // Fallback to API response data if fetch fails
          setUserInfo(res.data.userData);
        }
        Swal.fire({
          title: "Course Added Successfully",
          icon: "success",
        });
        const newData = {
          from: organizationData?.emailIntegration?.email,
          to: data?.email,
          templateType: "emailAction",
          organizationId: organizationData?._id,
          templateName: "courseWelcome",
          learner_name: data?.name,
          course_name: course?.bundleFullName,
          site_name: organizationData?.organizationName,
          site_email: organizationData?.email,
        };

        const updateOrg = await axios.post(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v1/sendMail`,
          // `http://localhost:5000/api/v1/sendMail`,
          newData
        );
        navigate("/courseAccess");
      }
      Loading().close();
      return;
    }

    const {
      data: { order },
    } = await axios.post(
      `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users/unpaidUsers/checkout`,
      {
        price: Math.round(+(+course.price - +couponDiscount)),
        paymentInstance: {
          key_id: organizationData?.paymentInstance?.key_id,
          key_secret: organizationData?.paymentInstance?.key_secret,
        },
        courses: course?.courses,
        email: data?.email,
      }
    );

    // console.log("Went to Line 135", order);

    const options = {
      key: organizationData?.paymentInstance?.key_id,
      amount: Math.round(+order?.amount),
      key_secret: organizationData?.paymentInstance?.key_secret,
      currency: "INR",
      name: organizationData?.organizationName,
      description: `Purchased ${course?.bundleFullName}`,
      image: organizationData?.org_logo,
      order_id: order?.id,
      prefill: {
        name: data?.name,
        email: data?.email,
        contact: data?.phone,
      },
      notes: {
        address: "Delhi, India",
      },
      theme: {
        color: organizationData?.titlesColor,
      },
      handler: async function (response) {
        response.razorpay_key_secret =
          organizationData?.paymentInstance?.key_secret;
        // response.courseId = course?._id;
        // response.batchId = selectedBatch?._id;
        response.courses = course?.courses;
        response.bundleId = course?._id;
        response.email = data?.email || user?.email;
        response.userId = data?._id;
        response.paidAmount = Math.round(+order?.amount / 100);
        response.originalPrice = Math.round(+course?.price);
        response.discountAmount = Math.round(+couponDiscount) || "";
        response.couponId = selectOffer._id || "";
        response.coupon = coupon || "";
        response.organizationId = organizationData?._id;
        response.organizationName = organizationData?.organizationName;
        // console.log("Response ========>", response);
        // console.log(selectOffer._id);
        Loading();

        try {
          const res = await axios.post(
            `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users/unpaidUsers/verifyBundlePayment`,
            response,
            { timeout: 60000 } // 60 second timeout for payment verification
          );

          Loading().close();

          if (res.data.success) {
            setUserInfo(res.data.userData);
            Swal.fire({
              title: "Courses Added Successfully",
              icon: "success",
            });

            const newData = {
              to: data?.email,
              templateType: "emailAction",
              templateName: "courseWelcome",
              organizationId: organizationData?._id,
              learner_name: data?.name,
              course_name: course?.bundleFullName,
              site_name: organizationData?.organizationName,
              site_email: organizationData?.email,
            };

            try {
              const updateOrg = await axios.post(
                `${process.env.REACT_APP_SERVERLESS_API}/api/v1/sendMail`,
                newData
              );
            } catch (emailError) {
              console.error("Email sending failed:", emailError);
            }

            navigate("/courseAccess");
          } else {
            console.error("Bundle payment verification failed:", res.data);
            Swal.fire({
              title: "Payment Verification Failed",
              text: `Your payment was successful but bundle enrollment failed. Please contact support with payment ID: ${response.razorpay_payment_id}`,
              icon: "error",
              confirmButtonText: "Okay",
            });

            // Store payment details for manual verification
            localStorage.setItem(
              "failedBundlePayment",
              JSON.stringify({
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                razorpay_key_secret: response.razorpay_key_secret,
                bundleId: response.bundleId,
                courses: response.courses,
                email: response.email,
                userId: response.userId,
                paidAmount: response.paidAmount,
                originalPrice: response.originalPrice,
                discountAmount: response.discountAmount,
                coupon: response.coupon,
                couponId: response.couponId,
                organizationId: response.organizationId,
                organizationName: response.organizationName,
                timestamp: new Date().toISOString(),
              })
            );

            navigate("/dashboard");
          }
        } catch (error) {
          Loading().close();
          console.error("Bundle payment verification API error:", error);

          Swal.fire({
            title: "Payment Processing Error",
            text: `Your payment was successful but we couldn't verify it. Please contact support with payment ID: ${response.razorpay_payment_id}`,
            icon: "error",
            showCancelButton: true,
            confirmButtonText: "Okay",
          }).then((result) => {
            if (result.isConfirmed) {
              // Retry bundle payment verification
              handleBundlePaymentRetry(response);
            }
          });

          // Store payment details for manual verification
          localStorage.setItem(
            "failedBundlePayment",
            JSON.stringify({
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              razorpay_key_secret: response.razorpay_key_secret,
              bundleId: response.bundleId,
              courses: response.courses,
              email: response.email,
              userId: response.userId,
              paidAmount: response.paidAmount,
              originalPrice: response.originalPrice,
              discountAmount: response.discountAmount,
              coupon: response.coupon,
              couponId: response.couponId,
              organizationId: response.organizationId,
              organizationName: response.organizationName,
              timestamp: new Date().toISOString(),
              error: error.message,
            })
          );
        }
      },
    };

    // console.log("Went to Line 188", options);

    const rzp1 = new window.Razorpay(options);
    // console.log("Went to Line 191", rzp1);
    rzp1.open();
    // console.log("Went to Line 192 ");
    Loading().close();
  };


  const handleLogin = async (event) => {
    event.preventDefault();
    const userAgent = window.navigator.userAgent;
    try {
      const userDevice = await axios.put(
        `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users/addDevice/${email}`,
        {
          device: userAgent,
        }
      );

      // Assuming your server returns a specific status code for device limit reached
      if (userDevice.status === 200) {
        await signIn(email, password).then(async () => {
          // After Firebase login, explicitly fetch and update userInfo from database
          try {
            const userResponse = await axios.get(
              `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${email.toLowerCase()}`
            );
            if (userResponse?.data?._id) {
              setUserInfo(userResponse.data);
              localStorage.setItem("userInfo", JSON.stringify(userResponse.data));
            }
          } catch (fetchError) {
            console.error("Error fetching user data after login:", fetchError);
          }
          toast.success("Login successful! You can now proceed with payment.");
        });
      }
      setLoginOpen(false);
    } catch (error) {
      console.error("Login error:", error);

      // Handle Firebase authentication errors
      if (error.code === 'auth/user-not-found' || error.code === 'auth/invalid-email') {
        Swal.fire({
          icon: "warning",
          title: "Email Not Registered",
          text: "This email is not registered. Would you like to create an account?",
          showCancelButton: true,
          confirmButtonText: "Yes, Register",
          cancelButtonText: "No, Try Again",
        }).then((result) => {
          if (result.isConfirmed) {
            // Close login modal and open register modal
            setLoginOpen(false);
            setRegisterOpen(true);
            // Clear the password field for security
            setPassword("");
          }
        });
      } else if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        // Fetch sign-in methods to determine if account uses Google or email/password
        const auth = getAuth();
        fetchSignInMethodsForEmail(auth, email)
          .then((methods) => {
            if (methods && methods.includes('google.com') && !methods.includes('password')) {
              // Account was registered with Google only
              Swal.fire({
                icon: "info",
                title: "Login Method Mismatch",
                html: `
                  <div style="text-align: left;">
                    <p>It looks like you registered with <strong>Google</strong>.</p>
                    <p>Please use the <strong>Google login button</strong> to access your account.</p>
                  </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Login with Google",
                cancelButtonText: "Try Again",
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  handleGoogleSignIn();
                }
              });
            } else {
              // Account has email/password - password was just wrong
              Swal.fire({
                icon: "error",
                title: "Invalid Password",
                text: "The password is incorrect. Please try again.",
              });
            }
          })
          .catch((err) => {
            console.error("Error fetching sign-in methods:", err);
            Swal.fire({
              icon: "error",
              title: "Invalid Password",
              text: "The password is incorrect. Please try again.",
            });
          });
      } else if (error?.response?.status === 400 || error?.response?.status === 404) {
        // Handle Axios 400/404 errors (device check failed, email not in DB)
        Swal.fire({
          icon: "warning",
          title: "Email Not Registered",
          text: "This email is not registered. Would you like to create an account?",
          showCancelButton: true,
          confirmButtonText: "Yes, Register",
          cancelButtonText: "No, Try Again",
        }).then((result) => {
          if (result.isConfirmed) {
            setLoginOpen(false);
            setRegisterOpen(true);
            setPassword("");
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: "Invalid Email or Password. Please try again.",
        });
      }
    }
  };

  const handleLogout = () => {
    logOut()
      .then((res) => {
        // console.log(res);
      })
      .catch((error) => console.error(error));
  };

  const validatePhone = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.length < 10) return false;
    const phoneRegex = /^\+[1-9]\d{10,14}$/;
    return phoneRegex.test(phoneNumber);
  };

  const handlePayNowClick = () => {
    if (user && userInfo?._id) {
      handleEnroll(userInfo);
    } else {
      toast.error("Please login first to proceed with payment.");
      setLoginOpen(true);
    }
  };

  const showRegistrationSuccessModal = () => {
    Swal.fire({
      title: "Registration Successful!",
      html: `
        <div style="text-align: center; padding: 20px 0;">
          <h3 style="color: #1f2937; font-size: 20px; font-weight: bold; margin-bottom: 12px;">Welcome to our platform!</h3>
          <p style="color: #6b7280; font-size: 14px; line-height: 1.5; margin-bottom: 20px;">
            Your account has been created successfully. Please login to proceed with payment and access your courses.
          </p>
        </div>
      `,
      icon: "success",
      showCancelButton: true,
      confirmButtonText: "Login to Continue",
      cancelButtonText: "I'll login later",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
      focusConfirm: true,
      heightAuto: false,
      backdrop: true,
      customClass: {
        container: "registration-success-container",
        popup: "registration-success-popup",
        confirmButton: "registration-success-confirm",
        cancelButton: "registration-success-cancel",
      },
      buttonsStyling: false,
      // Mobile-responsive styling
      width: window.innerWidth < 768 ? '90%' : '400px',
      didOpen: () => {
        // Add custom styling to buttons to match the payment flow
        const confirmBtn = document.querySelector('.registration-success-confirm');
        const cancelBtn = document.querySelector('.registration-success-cancel');

        if (confirmBtn) {
          confirmBtn.style.cssText = `
            background: #0891b2 !important;
            color: white !important;
            border: none !important;
            border-radius: 12px !important;
            padding: 12px 24px !important;
            font-weight: bold !important;
            font-size: 14px !important;
            margin: 0 8px !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            min-height: 48px !important;
            touch-action: manipulation !important;
            user-select: none !important;
          `;
          confirmBtn.onmouseover = () => confirmBtn.style.background = '#0891b2cc !important';
          confirmBtn.onmouseout = () => confirmBtn.style.background = '#0891b2 !important';
        }

        if (cancelBtn) {
          cancelBtn.style.cssText = `
            background: transparent !important;
            color: #6b7280 !important;
            border: none !important;
            padding: 12px 24px !important;
            font-size: 14px !important;
            margin: 0 8px !important;
            cursor: pointer !important;
            text-decoration: underline !important;
            min-height: 48px !important;
            touch-action: manipulation !important;
            user-select: none !important;
          `;
          cancelBtn.onmouseover = () => cancelBtn.style.color = '#374151 !important';
          cancelBtn.onmouseout = () => cancelBtn.style.color = '#6b7280 !important';
        }
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked "Login to Continue"
        setLoginOpen(true);
      }
      // For cancel/close, just dismiss the modal
    });
  };

  const handleGoogleSignIn = async () => {
    const googleProvider = new GoogleAuthProvider();

    providerLogin(googleProvider)
      .then(async (result) => {
        const email = result?.user?.email;

        // Validate email before API call
        if (!email || email === 'undefined' || email === 'null' || !email.includes('@')) {
          console.log("Invalid email from Google Sign-in:", email);
          toast.error("Invalid email received. Please try again.");
          handleLogout();
          return;
        }

        try {
          const userDetails = await axios.get(
            `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${email}`
          );

          if (userDetails?.data?.isUser === false || !userDetails?.data?._id) {
            Swal.fire({
              icon: "warning",
              title: "Email Not Registered",
              text: "This email is not registered. Would you like to create an account?",
              showCancelButton: true,
              confirmButtonText: "Yes, Register",
              cancelButtonText: "No, Try Again",
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                console.log("Modal opened");
              }
            }).then((result) => {
              if (result.isConfirmed) {
                setLoginOpen(false);
                setRegisterOpen(true);
              } else {
                handleLogout();
              }
            });
            return;
          } else {
            toast.success("Login successful! You can now proceed with payment.");
          }
          setLoginOpen(false);
        } catch (error) {
          console.error("Error validating user during Google Sign-in:", error);
          toast.error("Failed to verify user. Please try again.");
          handleLogout();
        }
      })
      .catch((error) => {
        console.error("Google Sign-in error:", error);
        toast.error("Google Sign-in failed. Please try again.");
      });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (
      validatePhone(phone) &&
      organizationData?._id &&
      organizationData?._id !== "undefined" &&
      organizationData?.organizationName &&
      password.length >= 6
    ) {
      setError(false);
      setIsSaving(true); // Prevent navigation during registration

      const data = {
        name,
        phone,
        email: email?.toLowerCase(),
        password,
        organizationId: organizationData?._id,
        organizationName: organizationData?.organizationName,
        role: "user",
        dateCreated,
      };

      console.log("Registration data:", data);

      try {
        // STEP 1: Check if user already exists in DB
        const existingUser = await axios.get(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${email?.toLowerCase()}`
        );

        if (existingUser?.data?._id) {
          setIsSaving(false);
          Swal.fire({
            icon: "warning",
            title: "Email Already Registered",
            text: "This email is already registered. Would you like to login instead?",
            showCancelButton: true,
            confirmButtonText: "Yes, Login",
            cancelButtonText: "No, Try Again",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              setRegisterOpen(false);
              setLoginOpen(true);
            }
          });
          return;
        }

        // STEP 2: Try to create Firebase user
        try {
          const result = await createUser(email, password);
          // Firebase created successfully, continue to DB creation
        } catch (firebaseError) {
          // If email already exists in Firebase (likely registered with Google),
          // just proceed to create DB record with email/password info
          if (firebaseError.code === 'auth/email-already-in-use') {
            console.log("Email exists in Firebase. Will create DB record with email/password info.");
            // Continue to step 3 - create DB record
            // The email/password info will be stored in DB even though Firebase has Google auth
            // At login time, the system will detect this and guide the user accordingly
          } else if (firebaseError.code === 'auth/weak-password') {
            toast.error("Password must be at least 6 characters long");
            setIsSaving(false);
            return;
          } else if (firebaseError.code === 'auth/invalid-email') {
            toast.error("Please enter a valid email address");
            setIsSaving(false);
            return;
          } else if (firebaseError.code === 'auth/network-request-failed') {
            toast.error("Network error. Please check your internet connection.");
            setIsSaving(false);
            return;
          } else {
            throw firebaseError;
          }
        }

        // STEP 3: Create DB record (whether Firebase is new or existing)
        const res = await axios.post(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users`,
          data
        );

        if (res.data.acknowledged) {
          // STEP 4: Send confirmation email
          try {
            const sendMail = await axios.post(
              `${process.env.REACT_APP_SERVERLESS_API}/api/v1/sendMail`,
              {
                to: email,
                templateType: "emailAction",
                templateName: "learnerSignUp",
                organizationId: organizationData?._id,
                learner_name: name,
              }
            );
          } catch (emailError) {
            console.error("Email sending failed:", emailError);
            // Don't fail the registration if email fails
          }

          setRegisterOpen(false);
          showRegistrationSuccessModal();
        } else {
          toast.error("Registration failed. Please try again.");
        }
      } catch (error) {
        console.error("Registration error:", error);
        if (error.code === 'auth/weak-password') {
          toast.error("Password must be at least 6 characters long");
        } else if (error.code === 'auth/email-already-in-use') {
          toast.error("This email is already registered. Please try logging in instead.");
        } else if (error.code === 'auth/invalid-email') {
          toast.error("Please enter a valid email address");
        } else if (error.code === 'auth/network-request-failed') {
          toast.error("Network error. Please check your internet connection.");
        } else {
          toast.error("Registration failed. Please try again.");
        }
      } finally {
        setIsSaving(false);
      }
    } else {
      if (!validatePhone(phone)) {
        setError(true);
        toast.error("Please enter a valid phone number");
      } else if (password.length < 6) {
        toast.error("Password must be at least 6 characters long");
      } else if (
        !organizationData?._id ||
        organizationData?._id === "undefined" ||
        !organizationData?.organizationName
      ) {
        toast.error("Please use the correct link and try again.");
      }
    }
  };

  const handleGoogleRegister = async () => {
    const googleProvider = new GoogleAuthProvider();

    if (
      validatePhone(phone) &&
      organizationData?._id &&
      organizationData?._id !== "undefined" &&
      organizationData?.organizationName
    ) {
      providerLogin(googleProvider)
        .then(async (result) => {
          const googleMail = result?.user?.email;
          const newName = result?.user?.displayName;

          try {
            // STEP 1: Check if user already exists in DB
            const userDetails = await axios.get(
              `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${googleMail}`
            );

            if (userDetails?.data?._id) {
              // User already registered - logout and show modal
              await logOut();
              setRegisterOpen(false);
              showRegistrationSuccessModal();
              setIsSaving(false);
              return;
            }

            // STEP 2: User not in DB, create DB record
            const res = await axios.post(
              `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users`,
              {
                email: googleMail,
                name: newName,
                phone,
                organizationId: organizationData?._id,
                organizationName: organizationData?.organizationName,
                role: "user",
                dateCreated,
              }
            );

            if (res.data.acknowledged) {
              // STEP 3: Send confirmation email
              try {
                const sendMail = await axios.post(
                  `${process.env.REACT_APP_SERVERLESS_API}/api/v1/sendMail`,
                  {
                    to: googleMail,
                    templateType: "emailAction",
                    templateName: "learnerSignUp",
                    organizationId: organizationData?._id,
                    learner_name: newName,
                  }
                );
              } catch (emailError) {
                console.error("Email sending failed:", emailError);
                // Don't fail the registration if email fails
              }

              // Logout user after registration to prevent auto-login
              await logOut();
              setRegisterOpen(false);
              showRegistrationSuccessModal();
            } else {
              // If database creation failed, logout and show error
              await logOut();
              toast.error(
                "Registration failed. Please try again or contact support."
              );
              console.error("Database user creation failed:", res.data);
            }
          } catch (error) {
            console.error("Google registration error:", error);
            // Logout on error to prevent auto-login
            await logOut();
            toast.error(
              "Registration failed. Please try again or use email registration."
            );
            // Important: Don't close the dialog on error so user can retry
          }
        })
        .catch(async (error) => {
          console.error("Firebase auth error:", error);
          // Logout on error to prevent auto-login
          await logOut();
          if (error.code === "auth/popup-closed-by-user") {
            // User closed the popup, don't show error
          } else {
            toast.error("Google sign-in failed. Please try again.");
          }
        })
        .finally(() => {
          setIsSaving(false); // Re-enable navigation
        });
    } else {
      if (!validatePhone(phone)) {
        setError(true);
        toast.error("Please enter a valid phone number");
      } else if (
        !organizationData?._id ||
        organizationData?._id === "undefined" ||
        !organizationData?.organizationName
      ) {
        toast.error("Please use the correct link and try again.");
      }
    }
  };

  // Refresh userInfo whenever the user state changes from auth context
  useEffect(() => {
    if (user?.email && userInfo?._id === undefined) {
      // Fetch fresh userInfo if it's not loaded yet
      axios
        .get(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v1/users?email=${user?.email}`
        )
        .then((response) => {
          if (response?.data?._id) {
            setUserInfo(response.data);
            localStorage.setItem("userInfo", JSON.stringify(response.data));
          }
        })
        .catch((error) => console.error("Error fetching user data:", error));
    }
  }, [user?.email, userInfo?._id, setUserInfo]);

  // console.log(course, organizationData);

  return (
    <>
      {course._id && organizationData._id ? (
        <div className="bg-[#f6f7ff91] min-h-[100vh]">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Payment</title>
          </Helmet>
          <Navbar
            setLoginOpen={setLoginOpen}
            organizationData={organizationData}
          />
          <div className="container mx-auto px-4 py-28">
            <div className="flex flex-col md:flex-row md:justify-center gap-20">
              <div>
                <div className="bg-[#F6F7FF] rounded-[20px] p-[20px] max-w-[340px] shadow-[4px_4px_4px_0px_#0000001a]">
                  <div>
                    <div className="card-content">
                      <div className="relative">
                        <img
                          className="w-full rounded-lg"
                          src={
                            course?.bundleThumbnail
                              ? course?.bundleThumbnail
                              : CourseTham
                          }
                          alt="CourseTham"
                        />
                      </div>
                      <h1 className="text-[#3E4DAC] text-[16px] font-[800] mt-[16px] mb-[12px]">
                        {course?.bundleFullName}
                      </h1>
                      <p className="text-[#7A7A7A] text-[12px] font-[500] mb-[16px]">
                        {course?.bundleDescription}
                      </p>
                      {/* <div className="flex items-center justify-between">
                    <p className="bg-[#E1D7FF] px-[16px] py-[8px] rounded-[16px] text-[12px] font-[600] ">
                      {course?.courseCategory}
                    </p>
                    <button className="bg-[#CEDBFF] px-[16px] py-[8px] rounded-[16px] text-[12px] font-[600] ">
                      {date?.toLocaleDateString("en-US", options)}
                    </button>
                  </div> */}
                    </div>
                  </div>
                </div>
                {/* <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 max-w-[340px] mt-6" role="alert">
                  <p className="font-bold">Warning</p>
                  <p>After Payment Success wait till it takes you to My Courses or you will not be added to the Course/Bundle</p>
                </div> */}
              </div>
              <div className="max-w-[350px] min-w-[350px]">
                <>
                  <div className="mt-3">
                    <h1 className=" text-black text-base font-[500] ">
                      Apply Coupon
                    </h1>
                    <div className="flex mt-1 border w-full rounded-md bg-white">
                      <div className="flex justify-between bg-transparent w-full p-2 focus:outline-none">
                        <input
                          className="outline-none"
                          type="text"
                          placeholder="Enter Coupon Code"
                          name="coupon"
                          value={coupon}
                          onChange={(e) => setCoupon(e.target.value)}
                        />
                        <div
                          onClick={() => {
                            setCoupon("");
                            setCouponDiscount(0);
                          }}
                          className="cursor-pointer"
                        >
                          {coupon.length >= 1 && <HighlightOffRoundedIcon />}
                        </div>
                      </div>
                      <button
                        onClick={() => handleApplyCoupon(coupon)}
                        className=" text-[#5e52ff] bg-[#5e52ff0c] p-2 rounded-sm"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                  {offers.length > 0 && (
                    <div className="mt-3">
                      <h1 className=" text-gray-400 mb-1 text-base font-[500] ">
                        Applicable Coupons
                      </h1>

                      <div className="flex gap-5 overflow-x-auto pb-3 scrollbar-container">
                        {offers?.map(
                          (offer, index) =>
                            offer?.suggestDuringCheckout &&
                            !offer?.disabled && (
                              <div
                                key={index}
                                onClick={() => {
                                  if (+offer?.maxUseCount < +offer?.usedCount) {
                                    Swal.fire({
                                      icon: "error",
                                      title: "Error",
                                      text: "Coupon is already been used Maximum Time",
                                    });
                                  } else {
                                    setCoupon(offer?.code);
                                    handleApplyCoupon(offer?.code);
                                  }
                                }}
                                className="bg-gradient-to-b cursor-pointer from-white to-[#ebf1ff] rounded-[7px] border border-blue px-[10px] py-[12px] min-w-[300px]"
                              >
                                <div className="flex items-center justify-between uppercase text-[1.25rem] font-bold">
                                  <h3>{offer?.discountPercent}%</h3>
                                  <h4 className=" text-blue">{offer?.code}</h4>
                                </div>
                                <p className=" flex items-center justify-between text-[14px]">
                                  <span>UPTO ₹{offer?.maxDiscountValue}</span>
                                  {/* <span>EXPIRES ON 31 Mar 2024</span> */}
                                  <span>
                                    EXPIRES ON{" "}
                                    {new Date(
                                      offer?.validTill
                                    )?.toLocaleDateString(undefined, {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </span>
                                </p>
                                <p className="mt-[10px] font-[600] text-[1.07rem]">
                                  Valid for first{" "}
                                  {+offer?.maxUseCount -
                                    (+offer?.usedCount || 0)}{" "}
                                  learners.{" "}
                                </p>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  )}
                  <hr className="my-6" />
                  <div className="mt-3">
                    <div className="p-3 border rounded-md shadow">
                      <label className=" text-[#2a2a2a80] py-2">
                        Price Details
                      </label>
                      <div className="table-responsive price-details">
                        <table className="table w-full">
                          <tbody>
                            <tr>
                              <td id="bundle-cost-name" className="py-2">
                                Total Price
                              </td>
                              <td id="bundle-cost" className="py-2">
                                ₹{Math.round(course?.price) || "N/A"}
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "table-row",
                              }}
                              className="py-2"
                            >
                              <td>Coupon Discount</td>
                              <td className="py-2" id="coupon-discount">
                                ₹
                                {couponDiscount >= 0
                                  ? Math.round(couponDiscount)
                                  : "N/A"}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot className="border-t">
                            <tr>
                              <td className="py-2">Total</td>
                              <td className="py-2" id="total-to-be-paid">
                                ₹
                                {course?.price
                                  ? Math.round(+course?.price - +couponDiscount)
                                  : "N/A"}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                  <hr className="mt-6" />
                  <div className="mt-3">
                    <div className="flex justify-between mb-5">
                      <div className="sum-block-details">
                        <p className="m-0">Net Payable amount</p>
                        <h4 className="m-0 text-2xl">
                          ₹
                          {course?.price
                            ? Math.round(+course?.price - +couponDiscount)
                            : "N/A"}
                        </h4>
                      </div>
                      <div>
                        {+course?.price - +couponDiscount === 0 ? (
                          <button
                            onClick={handlePayNowClick}
                            id="enroll-now-btn"
                            className=" px-[18px] py-[9px] text-white font-bold bg-blue rounded-md"
                          >
                            Enroll Now
                          </button>
                        ) : (
                          <button
                            onClick={handlePayNowClick}
                            id="enroll-now-btn"
                            className=" px-[18px] py-[9px] text-white font-bold bg-blue hover:bg-opacity-70 rounded-md"
                          >
                            Pay Now
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
          <DialogLayoutForFromControl
            open={loginOpen}
            setOpen={setLoginOpen}
            title={
              <p className=" h-[90px] text-[22px] font-[700] flex items-center text-[#3E4DAC] px-[32px] py-5 border-b-2">
                Login
              </p>
            }
            width={450}
            borderRadius="15px"
          >
            <LoginForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleLogin={handleLogin}
              registerOpen={registerOpen}
              setRegisterOpen={setRegisterOpen}
              loginOpen={loginOpen}
              setLoginOpen={setLoginOpen}
              handleGoogleSignIn={handleGoogleSignIn}
              setForgotPassOpen={setForgotPassOpen}
            />
          </DialogLayoutForFromControl>
          {forgotPassOpen && (
            <ForgotPassword
              setForgotPassOpen={setForgotPassOpen}
              forgotPassOpen={forgotPassOpen}
            />
          )}
          <DialogLayoutForFromControl
            open={registerOpen}
            setOpen={setRegisterOpen}
            title={
              <p className=" h-[90px] text-[22px] font-[700] flex items-center text-[#3E4DAC] px-[32px] py-5 border-b-2">
                Register
              </p>
            }
            width={450}
            borderRadius="15px"
          >
            <RegisterForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleRegister={handleRegister}
              registerOpen={registerOpen}
              setRegisterOpen={setRegisterOpen}
              loginOpen={loginOpen}
              setLoginOpen={setLoginOpen}
              name={name}
              setName={setName}
              phone={phone}
              setPhone={setPhone}
              error={error}
              handleGoogleRegister={handleGoogleRegister}
            />
          </DialogLayoutForFromControl>

        </div>
      ) : (
        <div className="bg-[#f6f7ff91] min-h-[100vh]">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Payment</title>
          </Helmet>
          <NavbarSkeletonLoader />
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row md:justify-center gap-20">
              <div className="relative">
                <div className="flex flex-col m-8 shadow-md w-60 sm:w-80 animate-pulse rounded-lg">
                  <div className="h-48 bg-gray-200 rounded-t-lg"></div>
                  <div className="flex-1 px-4 py-8 space-y-4 sm:p-8 bg-gray-400 rounded-b-lg">
                    <div className="w-full h-6 bg-gray-200 rounded-lg"></div>
                  </div>
                </div>
              </div>
              <div className="max-w-[350px] min-w-[350px]">
                <div className="mt-3">
                  <h1 className=" text-black text-base font-[500] mb-3">
                    <div className="w-1/3 h-8 bg-gray-200 rounded-lg"></div>
                  </h1>
                  <div className="flex flex-wrap">
                    <div className="w-full h-10 bg-gray-400 rounded-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BundlePayment;
